import {
  ChildDetailsQueryParams,
  ChildQueryParamNames,
  CoverageQueryParam,
  QueryParamNames,
  SopSicknessLeaveQueryParamNames,
  SopSicknessLeaveQueryParams,
  TravelCoverageQueryParam,
  TravelPriceQueryParams,
  TravelQueryParamNames,
} from "./checkPriceTypes";

import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { isDefined } from "Utils/functions";
import { getSearchQuery } from "Utils/globals";

export const hasQueryParams = (): boolean => {
  const query = getSearchQuery();
  return (
    query.has(QueryParamNames.COVERAGE) ||
    query.has(TravelQueryParamNames.FAMILY_COVERAGE) ||
    query.has(QueryParamNames.DAMAGE_RECENT_YEARS) ||
    query.has(QueryParamNames.INJURY_YEAR)
  );
};

export const getCoverageQueryParam = (): CoverageQueryParam | null => {
  const query = getSearchQuery();
  return getCoverageParam(query);
};

export const getTravelPriceQueryParams = (): TravelPriceQueryParams => {
  const query = getSearchQuery();
  return {
    coverage: getCoverageParam(query) as TravelCoverageQueryParam,
    familyCoverage: getBooleanParam(
      query,
      TravelQueryParamNames.FAMILY_COVERAGE,
    ),
    injuries: getDamageRecentYearsParam(query),
    injuryYear: getStringParam(query, QueryParamNames.INJURY_YEAR),
  };
};

export const getChildDetailsQueryParams = (): ChildDetailsQueryParams => {
  const query = getSearchQuery();
  return {
    childIndex: getNumberParam(query, ChildQueryParamNames.CHILD_INDEX),
  };
};

const getCoverageParam = (query: URLSearchParams): CoverageQueryParam | null =>
  query.has(QueryParamNames.COVERAGE)
    ? (query
        .get(QueryParamNames.COVERAGE)
        ?.toLocaleUpperCase() as CoverageQueryParam)
    : null;

const getStringParam = (query: URLSearchParams, param: string): string | null =>
  query.has(param) ? query.get(param) : null;

const getNumberParam = (
  query: URLSearchParams,
  param: string,
): number | null => {
  const stringParam = getStringParam(query, param);
  return isDefined(stringParam) && !isNaN(parseInt(stringParam))
    ? Number(stringParam)
    : null;
};

const getDamageRecentYearsParam = (
  query: URLSearchParams,
): DamageRecentYears | null => {
  if (query.has(QueryParamNames.DAMAGE_RECENT_YEARS)) {
    const value = query.get(QueryParamNames.DAMAGE_RECENT_YEARS);
    return value === DamageRecentYears.NONE ||
      value === DamageRecentYears.ONE ||
      value === DamageRecentYears.TWO_OR_MORE
      ? (value as DamageRecentYears)
      : null;
  }
  return null;
};

const getBooleanParam = (
  query: URLSearchParams,
  param: string,
): boolean | null => (query.has(param) ? query.get(param) === "true" : null);

export const getSopSicknessLeaveParams = (): SopSicknessLeaveQueryParams => {
  const query = getSearchQuery();
  return {
    dailyPayoutAmount: getNumberParam(
      query,
      SopSicknessLeaveQueryParamNames.DAILY_PAYOUT_AMOUNT,
    ),
    revenue: getNumberParam(query, SopSicknessLeaveQueryParamNames.REVENUE),
  };
};
